(() => {
  // DOM Elements
  const facetToggles = document.querySelectorAll(".multi-select-toggle");
  const toggleFacets = document.querySelectorAll(".toggle-facet input[type='checkbox']");
  const resetAllButton = document.querySelector(".js-reset-all");
  const collectionDrawerButton = document.querySelector(
    ".collection-drawer-button"
  );
  const closeDrawerButton = document.getElementById("closeDrawer");
  const collectionDrawer = document.getElementById("collection-drawer");
  const collectionDrawerOverlay = document.querySelector(
    ".collection-drawer__overlay"
  );

  console.log("Collection.js initialized");
  console.log("Found facet toggles:", facetToggles.length);
  console.log("Found toggle facets:", toggleFacets.length);
  console.log("Reset button found:", !!resetAllButton);
  console.log("Collection drawer button found:", !!collectionDrawerButton);
  console.log("Close drawer button found:", !!closeDrawerButton);
  console.log("Collection drawer found:", !!collectionDrawer);
  console.log("Collection drawer overlay found:", !!collectionDrawerOverlay);

  // Initialize facet state
  const facetState = {};

  // Normalize facet field names to prevent duplicates
  const normalizeFacetField = (field) => {
    // Ensure we always use the prefixed version for consistency
    if (field.startsWith("v.option.") && !field.startsWith("filter.")) {
      return `filter.${field}`;
    }

    // If it already has filter prefix, keep it as is
    if (field.startsWith("filter.")) {
      return field;
    }

    // Otherwise, add the filter prefix
    return `filter.${field}`;
  };

  // Toggle dropdown visibility
  const toggleDropdown = (toggle) => {
    const dropdown = toggle.nextElementSibling;
    const isExpanded = toggle.getAttribute("aria-expanded") === "true";

    console.log("Toggling dropdown for:", toggle.textContent.trim());
    console.log("Current expanded state:", isExpanded);

    // Close all other dropdowns first
    facetToggles.forEach((otherToggle) => {
      if (otherToggle !== toggle) {
        otherToggle.setAttribute("aria-expanded", "false");
        otherToggle.nextElementSibling.classList.remove("active");
      }
    });

    // Toggle current dropdown
    toggle.setAttribute("aria-expanded", !isExpanded);
    dropdown.classList.toggle("active");
    console.log("New expanded state:", !isExpanded);
  };

  // Handle facet selection
  const handleFacetSelection = (checkbox) => {
    const facetContainer = checkbox.closest(".multi-select-facet") || checkbox.closest(".toggle-facet");
    let facetField;
    
    if (facetContainer) {
      facetField = facetContainer.dataset.facetField || checkbox.id;
    } else {
      facetField = checkbox.id;
    }
    
    const value = checkbox.value || "true";

    // Normalize the facet field to prevent duplicates
    facetField = normalizeFacetField(facetField);

    console.log(
      "Facet selection changed:",
      facetField,
      value,
      checkbox.checked
    );

    // Initialize facet field if it doesn't exist
    if (!facetState[facetField]) {
      facetState[facetField] = new Set();
      console.log("Initialized new facet field:", facetField);
    }

    // Add or remove value from state
    if (checkbox.checked) {
      facetState[facetField].add(value);
      console.log("Added value to facet state:", value);
    } else {
      facetState[facetField].delete(value);
      console.log("Removed value from facet state:", value);
    }

    // Update URL and refresh products
    updateUrlAndRefreshProducts();
  };

  // Update URL and refresh products based on selected facets
  const updateUrlAndRefreshProducts = () => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    console.log("Updating URL with current facet state:", facetState);

    // Clear existing filter params
    Array.from(params.keys()).forEach((key) => {
      if (key.startsWith("filter.")) {
        console.log("Removing existing filter param:", key);
        params.delete(key);
      }
    });

    console.log(facetState);

    // Add current filters to params
    Object.entries(facetState).forEach(([field, values]) => {
      if (values.size > 0) {
        // For each field and its values
        Array.from(values).forEach((value) => {
          // Ensure we're using the normalized field name
          const paramKey = normalizeFacetField(field);
          console.log(`Setting filter param: ${paramKey} = ${value}`);
          params.append(paramKey, value);
        });
      }
    });

    // Redirect to the new URL
    url.search = params.toString();
    console.log("Redirecting to new URL:", url.toString());
    /* window.location.href = url.toString(); */

    // Note: The following code won't execute immediately due to the redirect
    // but is kept for when this function is called during initialization

    // Update facet count indicators
    updateFacetCountIndicators();
  };

  // Update facet count indicators
  const updateFacetCountIndicators = () => {
    console.log("Updating facet count indicators");
    
    // Create a map to track unique field names without the "filter." prefix
    const normalizedFieldCounts = new Map();
    
    // First, aggregate counts by normalized field name
    Object.entries(facetState).forEach(([field, values]) => {
      // Normalize field by removing any "filter." prefixes
      const normalizedField = field.replace(/^(filter\.)+/, "");
      
      if (!normalizedFieldCounts.has(normalizedField)) {
        normalizedFieldCounts.set(normalizedField, new Set());
      }
      
      // Add all values to the normalized field's set
      values.forEach(value => normalizedFieldCounts.get(normalizedField).add(value));
    });
    
    // Now update the UI with the aggregated counts
    normalizedFieldCounts.forEach((uniqueValues, normalizedField) => {
      const toggle =
        document.querySelector(
          `.multi-select-facet[data-facet-field="${normalizedField}"] .multi-select-toggle`
        );

      if (!toggle) {
        console.warn(`Toggle element not found for facet field: ${normalizedField}`);
        return;
      }

      const countElement = toggle.querySelector(".selected--facets__count");
      const count = uniqueValues.size;
      console.log(`Normalized facet ${normalizedField} has ${count} selected values`);

      if (count > 0) {
        if (countElement) {
          countElement.textContent = count;
          console.log(`Updated count for ${normalizedField} to ${count}`);
        } else {
          const countSpan = document.createElement("span");
          countSpan.className = "selected--facets__count";
          countSpan.textContent = count;
          toggle.appendChild(countSpan);
          console.log(`Created new count element for ${normalizedField}: ${count}`);
        }
      } else if (countElement) {
        countElement.remove();
        console.log(`Removed count element for ${normalizedField} (no values)`);
      }
    });
  };

  // Reset all filters
  const resetAllFilters = () => {
    console.log("Resetting all filters");

    // Clear facet state
    Object.keys(facetState).forEach((key) => {
      console.log(`Clearing facet state for: ${key}`);
      facetState[key].clear();
    });

    // Uncheck all checkboxes
    const checkboxes = document.querySelectorAll(
      '.multi-select-option input[type="checkbox"], .toggle-facet input[type="checkbox"]'
    );
    console.log(`Unchecking ${checkboxes.length} checkboxes`);
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Update URL and refresh products
    updateUrlAndRefreshProducts();
  };

  // Filter options in dropdown based on search input
  const filterOptions = (searchInput) => {
    const dropdown = searchInput.closest(".multi-select-dropdown");
    const searchTerm = searchInput.value.toLowerCase();
    console.log(`Filtering dropdown options with search term: "${searchTerm}"`);

    const options = dropdown.querySelectorAll(".multi-select-option");
    let visibleCount = 0;

    options.forEach((option) => {
      const label = option.querySelector("label").textContent.toLowerCase();
      const isVisible = label.includes(searchTerm);
      option.style.display = isVisible ? "" : "none";
      if (isVisible) visibleCount++;
    });

    console.log(
      `Filter results: ${visibleCount} of ${options.length} options visible`
    );
  };

  // Toggle collection drawer
  const toggleCollectionDrawer = () => {
    const isActive = collectionDrawer.classList.contains("active");
    console.log(`${isActive ? "Closing" : "Opening"} collection drawer`);

    collectionDrawer.classList.toggle("active");
    collectionDrawerOverlay.classList.toggle("active");
    document.body.classList.toggle("drawer-open");
  };

  // Initialize from URL params
  const initFromUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    console.log("Initializing from URL params:", params.toString());

    // Process each filter parameter
    Array.from(params.entries()).forEach(([key, value]) => {
      if (key.startsWith("filter.")) {
        // Normalize the field name to prevent duplicates
        const normalizedKey = normalizeFacetField(key);
        const field = normalizedKey;
        console.log(`Found filter in URL: ${field} with value: ${value}`);

        // Initialize facet field if it doesn't exist
        if (!facetState[normalizedKey]) {
          facetState[normalizedKey] = new Set();
          console.log(`Initialized facet state for ${normalizedKey}`);
        }

        // Add value and check corresponding checkbox
        facetState[normalizedKey].add(value);

        // Try to find checkbox with either the normalized or original field name
        let checkbox = document.querySelector(`input[id="${field}||${value}"]`);
        console.log(field, value, checkbox);
        if (!checkbox) {
          checkbox = document.querySelector(
            `input[id="${key.replace("filter.", "")}||${value}"]`
          );
        }
        
        // For toggle facets, try to find by ID directly
        if (!checkbox) {
          checkbox = document.querySelector(`input[id="${field}"]`);
          
          // If this is a toggle facet, make sure it's checked
          if (checkbox && checkbox.closest(".toggle-facet")) {
            checkbox.checked = true;
            console.log(`Checked toggle facet for ${field}`);
          }
        }

        if (checkbox) {
          checkbox.checked = true;
          console.log(`Checked checkbox for ${field}=${value}`);
        } else {
          console.warn(`Checkbox not found for ${field}=${value}`);
        }
      }
    });

    // Update facet count indicators
    updateFacetCountIndicators();
  };

  // Event Listeners
  document.addEventListener("DOMContentLoaded", () => {
    console.log("DOM fully loaded, setting up event listeners");

    // Facet toggle click events
    facetToggles.forEach((toggle) => {
      toggle.addEventListener("click", () => toggleDropdown(toggle));
      console.log(
        "Added click listener to facet toggle:",
        toggle.textContent.trim()
      );
    });

    // Checkbox change events for multi-select facets
    const checkboxes = document.querySelectorAll(
      '.multi-select-option input[type="checkbox"]'
    );
    console.log(`Setting up ${checkboxes.length} checkbox change listeners`);
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => handleFacetSelection(checkbox));
    });
    
    // Checkbox change events for toggle facets
    console.log(`Setting up ${toggleFacets.length} toggle facet change listeners`);
    toggleFacets.forEach((checkbox) => {
      checkbox.addEventListener("change", () => handleFacetSelection(checkbox));
    });

    // Reset all button click event
    if (resetAllButton) {
      resetAllButton.addEventListener("click", resetAllFilters);
      console.log("Added click listener to reset all button");
    }

    // Search input events
    const searchInputs = document.querySelectorAll(
      ".multi-select-search-input"
    );
    console.log(`Setting up ${searchInputs.length} search input listeners`);
    searchInputs.forEach((input) => {
      input.addEventListener("input", () => filterOptions(input));
    });

    // Collection drawer toggle
    if (collectionDrawerButton) {
      collectionDrawerButton.addEventListener("click", toggleCollectionDrawer);
      console.log("Added click listener to collection drawer button");
    }

    // Close drawer button
    if (closeDrawerButton) {
      closeDrawerButton.addEventListener("click", toggleCollectionDrawer);
      console.log("Added click listener to close drawer button");
    }

    // Drawer overlay click
    if (collectionDrawerOverlay) {
      collectionDrawerOverlay.addEventListener("click", toggleCollectionDrawer);
      console.log("Added click listener to drawer overlay");
    }

    // Close dropdowns when clicking outside
    document.addEventListener("click", (event) => {
      if (!event.target.closest(".multi-select-facet")) {
        console.log("Click outside facet detected, closing all dropdowns");
        facetToggles.forEach((toggle) => {
          toggle.setAttribute("aria-expanded", "false");
          toggle.nextElementSibling.classList.remove("active");
        });
      }
    });

    // Initialize from URL params
    initFromUrlParams();
    console.log("Initialization complete");
  });
})();
